import { PROCESS_STEPS } from "../lib/constants";
import { useReveal } from "../hooks/useReveal";

export default function Process() {
  const [ref, visible] = useReveal();
  return (
    <section
      id="process"
      data-testid="process-section"
      className="py-24 md:py-32 bg-[#FFFFFF] relative"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-16">
          <span className="gold-divider mb-5">How It Works</span>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light text-[#005165] leading-[1.08]">
            Getting started is <em className="not-italic text-[#AC9667]">simple.</em>
          </h2>
          <p className="mt-5 text-lg text-[#4B5563] max-w-2xl leading-relaxed">
            A calm, clear path from your first call to the first day of care — no pressure, no surprises.
          </p>
        </div>

        <div
          ref={ref}
          className={`relative grid grid-cols-1 md:grid-cols-5 gap-6 ${visible ? 'reveal visible' : 'opacity-0'}`}
        >
          {/* connecting line on desktop */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-px bg-gradient-to-r from-transparent via-[#AC9667]/40 to-transparent" aria-hidden="true" />

          {PROCESS_STEPS.map((s, i) => (
            <div
              key={s.num}
              data-testid={`process-step-${i + 1}`}
              className="relative flex flex-col items-start"
            >
              <div className="relative z-10 w-24 h-24 rounded-full bg-white border border-[#E5DDC9] flex items-center justify-center shadow-[0_10px_30px_-12px_rgba(15,23,42,0.18)] mb-5">
                <span className="font-serif text-3xl text-[#AC9667]">{s.num}</span>
              </div>
              <h3 className="font-serif text-2xl text-[#005165] mb-2">{s.title}</h3>
              <p className="text-[15px] text-[#4B5563] leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
